import { apiAuth, apiRegistration, AuthError } from "scripts/api/auth";
import { showUserBadge } from "./badge";
import { closeAuthModal } from "./auth";
import { MessageToast } from "../components/toast";
import { ERR_NETWORK } from "../components/errors";

/** Текст ошибки: нет связи → ERR_NETWORK; иначе причина с сервера или фолбэк. */
const authErrorText = (err: unknown, fallback: string): string => {
  if (err instanceof AuthError) {
    if (err.isNetwork) return ERR_NETWORK;
    if (err.message) return err.message;
  }
  return fallback;
};

export const initRegAuthForms = (onLogin?: () => void) => {
  initRegistrationForm(onLogin);
  initAuthForm(onLogin);
};

const initRegistrationForm = (onLogin?: () => void) => {
  const registrationSumitBtn = document.getElementById("regSubmitBtn");
  const loginInput = document.getElementById("registrationLoginInput");
  const passwordInput = document.getElementById("registrationPasswordInput");
  const passwordRepeatInput = document.getElementById(
    "registrationRepeatPasswordInput",
  );

  if (
    !(loginInput instanceof HTMLInputElement) ||
    !(passwordInput instanceof HTMLInputElement) ||
    !(passwordRepeatInput instanceof HTMLInputElement)
  ) {
    throw new Error("Ошибка ! Инпуты для регистрации не найдены!");
  }

  registrationSumitBtn?.addEventListener("click", async () => {
    if (passwordInput.value != passwordRepeatInput.value) {
      MessageToast.showDanger("auth", "Ошибка. Пароли не совпадают.");
      return;
    }
    try {
      const result = await apiRegistration(loginInput.value, passwordInput.value);
      closeAuthModal();
      showUserBadge(result.login);
      MessageToast.success(
        "auth",
        `Вы успешно зарегистрировались!: ${result.login}`,
      );
      onLogin?.();
    } catch (err) {
      MessageToast.showDanger(
        "auth",
        authErrorText(err, "Не удалось зарегистрироваться, попробуйте ещё раз"),
      );
    }
  });
};

const initAuthForm = (onLogin?: () => void) => {
  const authSumitBtn = document.getElementById("authSubmitBtn");
  const loginInput = document.getElementById("authLoginInput");
  const passwordInput = document.getElementById("authPasswordInput");

  if (
    !(loginInput instanceof HTMLInputElement) ||
    !(passwordInput instanceof HTMLInputElement)
  ) {
    throw new Error("Ошибка ! Инпуты для авторизации не найдены!");
  }

  authSumitBtn?.addEventListener("click", async () => {
    try {
      const result = await apiAuth(loginInput.value, passwordInput.value);
      closeAuthModal();
      showUserBadge(result.login);
      MessageToast.success(
        "auth",
        `Вы успешно вошли в аккаунт: ${result.login}`,
      );
      onLogin?.();
    } catch (err) {
      MessageToast.showDanger(
        "auth",
        authErrorText(err, "Не удалось войти, попробуйте ещё раз"),
      );
    }
  });
};
